module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "user-caller-form"
  }, [_c('fieldset', {
    attrs: {
      "enabled": ""
    }
  }, [_c('form', {
    staticClass: "form-horizontal user-caller-form",
    attrs: {
      "form": "",
      "id": _vm._uid
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.onClickCancel($event)
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onClickSave($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label ",
    staticStyle: {
      "color": "#aaa"
    },
    attrs: {
      "for": "sex"
    }
  }, [_vm._v(_vm._s(_vm.getInfoText) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-default",
    class: {
      'cc-required': _vm.caller.idSex == 0, active: _vm.caller.idSex == 1
    },
    on: {
      "click": function($event) {
        _vm.caller.idSex = 1
      }
    }
  }, [_vm._v(" Herr ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-default",
    class: {
      'cc-required': _vm.caller.idSex == 0, active: _vm.caller.idSex == 2
    },
    on: {
      "click": function($event) {
        _vm.caller.idSex = 2
      }
    }
  }, [_vm._v(" Frau ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.idPertitel),
      expression: "caller.idPertitel"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.caller, "idPertitel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.UserConf.PERTITEL), function(option) {
    return _c('option', {
      domProps: {
        "value": option.VALUE
      }
    }, [_vm._v("\n              " + _vm._s(option.TEXT) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.customerNumber),
      expression: "caller.customerNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "customer-number",
      "placeholder": "Kundennummer"
    },
    domProps: {
      "value": (_vm.caller.customerNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller, "customerNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label ",
    attrs: {
      "for": "last-name"
    }
  }, [_vm._v("Nachname:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.lastName),
      expression: "caller.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "last-name",
      "placeholder": "Nachname",
      "required": ""
    },
    domProps: {
      "value": (_vm.caller.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary xxform-control",
    attrs: {
      "type": "button",
      "title": "tausche Nachname Vorname"
    },
    on: {
      "click": _vm.toggleFirstLastName
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-transfer",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "first-name"
    }
  }, [_vm._v("Vorname:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.firstName),
      expression: "caller.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "first-name",
      "placeholder": "Vorname"
    },
    domProps: {
      "value": (_vm.caller.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "caller-adresse"
    }
  }, [_c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "caller-street"
    }
  }, [_vm._v("Straße:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.street),
      expression: "caller.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "caller-street",
      "placeholder": "Straße"
    },
    domProps: {
      "value": (_vm.caller.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller, "street", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "caller-street-number"
    }
  }, [_vm._v("Hausnummer:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.streetNumber),
      expression: "caller.streetNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "caller-street-number",
      "placeholder": "Hausnummer"
    },
    domProps: {
      "value": (_vm.caller.streetNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller, "streetNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "plz"
    }
  }, [_vm._v("PLZ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.zipCode),
      expression: "caller.zipCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1000",
      "max": "99999",
      "id": "zip-code",
      "placeholder": "PLZ"
    },
    domProps: {
      "value": (_vm.caller.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller, "zipCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "ort"
    }
  }, [_vm._v("Ort:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.city),
      expression: "caller.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "caller-city",
      "placeholder": "Ort"
    },
    domProps: {
      "value": (_vm.caller.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller, "city", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nachname"
    }
  }, [_vm._v("VIP:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.info),
      expression: "caller.info"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "caller-info",
      "placeholder": "Besondere Hinweise zum Anrufer"
    },
    domProps: {
      "value": (_vm.caller.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller, "info", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.caller.idCompany > 0),
      expression: "caller.idCompany > 0"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2  control-label"
  }, [_vm._v("Firma:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_c('strong', [_vm._v(_vm._s(_vm.caller.company.name))]), _vm._v("\n           - "), _c('small', [_vm._v(_vm._s(_vm.caller.company.street))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.company.streetNumber) + ",")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.company.zipCode))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.caller.company.city))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary xxform-control",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#company-adress",
      "title": "Firmenzuordnung aufheben"
    },
    on: {
      "click": _vm.resetCallerCompany
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.caller.idCompany == 0 && _vm.caller.company.name == ''),
      expression: "caller.idCompany == 0 && caller.company.name == ''"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2  control-label"
  }, [_vm._v("Firma:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('company-caller-typeahead', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.caller.company.id),
      expression: "!caller.company.id"
    }]
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.caller.idCompany == 0 && _vm.caller.company.name),
      expression: "caller.idCompany == 0 && caller.company.name"
    }]
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "company-name"
    }
  }, [_vm._v("Neue Firma:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.company.name),
      expression: "caller.company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company-name",
      "placeholder": "Firmennamen"
    },
    domProps: {
      "value": (_vm.caller.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller.company, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default form-control",
    attrs: {
      "type": "button",
      "title": "lösche inhalt"
    },
    on: {
      "click": _vm.resetCallerCompany
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "company-adress"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "company-street"
    }
  }, [_vm._v("Straße:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.company.street),
      expression: "caller.company.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company-street",
      "placeholder": "der Firma"
    },
    domProps: {
      "value": (_vm.caller.company.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller.company, "street", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "company-street-number"
    }
  }, [_vm._v("Hausnummer:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.company.streetNumber),
      expression: "caller.company.streetNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company-street-number",
      "placeholder": "der Firma"
    },
    domProps: {
      "value": (_vm.caller.company.streetNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller.company, "streetNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "company-zip-code"
    }
  }, [_vm._v("PLZ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.company.zipCode),
      expression: "caller.company.zipCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company-zip-code",
      "placeholder": "der Firma"
    },
    domProps: {
      "value": (_vm.caller.company.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller.company, "zipCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "company-city"
    }
  }, [_vm._v("Ort:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caller.company.city),
      expression: "caller.company.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "company-city",
      "placeholder": "der Firma"
    },
    domProps: {
      "value": (_vm.caller.company.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.caller.company, "city", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-kombox-items"
  }, _vm._l((_vm.caller.komboxes), function(kombox) {
    return _c('div', {}, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (kombox.datetimeEnd),
        expression: "kombox.datetimeEnd"
      }],
      staticClass: "row cc-kombox-item"
    }, [_c('div', {
      staticClass: "col-sm-2 text-right",
      staticStyle: {
        "padding-right": "0px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kombox.type),
        expression: "kombox.type"
      }],
      staticClass: "form-control text-right",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kombox, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.KomboxConf.TYPES_USERCALLER), function(option) {
      return _c('option', {
        domProps: {
          "value": option.OPTION.VALUE
        }
      }, [_vm._v("\n                " + _vm._s(option.OPTION.TEXT) + "\n              ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-5",
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kombox.content),
        expression: "kombox.content"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "pattern": _vm.KomboxConf.TYPES[kombox.type].CONTENT.PATTERN,
        "placeholder": _vm.KomboxConf.TYPES[kombox.type].CONTENT.PLACEHOLDER,
        "title": _vm.KomboxConf.TYPES[kombox.type].CONTENT.PLACEHOLDER
      },
      domProps: {
        "value": (kombox.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(kombox, "content", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4",
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kombox.description),
        expression: "kombox.description"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "privat, office ..."
      },
      domProps: {
        "value": (kombox.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(kombox, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 text-right"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "type": "button",
        "title": "löschen"
      },
      on: {
        "click": function($event) {
          kombox.datetimeEnd = '', kombox.content = ''
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('div', {
    staticClass: "col-sm-11"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn cc-attention",
    attrs: {
      "type": "submit",
      "form": _vm._uid
    }
  }, [_vm._v("\n            Speichern\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickCancel
    }
  }, [_vm._v("\n            Abbrechen\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary xxform-control",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickAddKombox
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary xxform-control",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#caller-adresse",
      "title": "Anrufer Adresse"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("DE "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("D")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("AT")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CH")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("RU")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary xxform-control",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#company-adress",
      "title": "Firmen Adresse"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09c6b786!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserCallerForm.vue
// module id = 260
// module chunks = 0